import {
  Toolbar,
  Typography,
  useMediaQuery,
  useTheme,
  IconButton,
  Tooltip,
  Box,
} from '@mui/material';
import { FC } from 'react';
import { getCount } from '../../../components/Draft/CharCounter/utils';
import { ArticleState } from '../reducer';
import { useStyles } from './styles';
import { DraftCharCounterIcon } from '../../../components/Draft/DraftWithBlockCounter/DraftCharCounterIcon';

type ArticleToolBarProps = Pick<ArticleState, 'title' | 'lead' | 'body'> & {
  brandLabel?: string;
  showBlockCounters?: boolean;
  onToggleBlockCounters?: () => void;
};

function getTotalTextCount(params: ArticleToolBarProps) {
  const { title, lead, body } = params;
  const titleCount = getCount(title);
  const leadCount = getCount(lead, 'Draft');
  const bodyCount = getCount(body, 'Draft');

  const totalChars =
    titleCount.charCount + leadCount.charCount + bodyCount.charCount;
  const totalWords =
    titleCount.wordCount + leadCount.wordCount + bodyCount.wordCount;
  return `${totalChars} caractère${
    totalChars > 1 ? 's' : ''
  } - ${totalWords} mot${totalWords > 1 ? 's' : ''}`;
}

export const ArticleToolBar: FC<ArticleToolBarProps> = ({
  title,
  lead,
  body,
  brandLabel,
  showBlockCounters = false,
  onToggleBlockCounters,
}) => {
  const classes = useStyles();
  const theme = useTheme();
  const smallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const totalTextCount = getTotalTextCount({ title, lead, body });

  return (
    <Toolbar className={classes.toolbar} variant="dense">
      <div className={classes.wordCountMessage}>
        {!smallScreen && <Typography>Total de l'article :</Typography>}
        <Typography className={classes.globalCharCounter}>
          {totalTextCount}
        </Typography>
      </div>
      <Box display="flex" alignItems="center" gap={1}>
        {onToggleBlockCounters && (
          <Tooltip title="Afficher le nombre de caractères des paragraphes">
            <IconButton
              size="small"
              onClick={onToggleBlockCounters}
              sx={{
                marginLeft: 1,
                color: showBlockCounters ? '#424242' : 'grey.600',
                opacity: showBlockCounters ? 1 : 0.5,
                '&:hover': {
                  color: 'primary.main',
                },
              }}
            >
              <DraftCharCounterIcon />
            </IconButton>
          </Tooltip>
        )}
        {brandLabel && <Typography variant="h6">{brandLabel}</Typography>}
      </Box>
    </Toolbar>
  );
};
